import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'

import {
  Table,
  Jumbotron,
  Button,
  Tabs,
  Tab,
  Row,
  Grid,
  Col,
  Modal,
  Image,
  Panel,
  ButtonGroup,
  FormControl,
  FormGroup,
  ControlLabel,
  Alert,
  Label
} from 'react-bootstrap';

import If from "../../utils/If"

import { categorysListUtils } from "../../utils/categorys-exercises"

import Loader from 'react-loader-advanced';

import '../../statics/css/treinos-list.css'
import '../../statics/css/util.css'

import videoPlayerIcon from '../../statics/images/video_player.svg'

//DAO
import { sendGifFileStorage } from '../../dao-firebase/daofirebase';
import { registerExercise, updateExercise } from '../../dao-firebase/exercise-firebase';
import TabsExercises from './tabs-exercises';

import TableExercises from './table-exercises';
import TableTrainings from './table-trainings';

class TrainingsList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      //new exercise
      form_category_exercise: '',
      form_name_exercise: '',
      form_description_exercise: '',
      form_category_exercise: '',
      form_url_gif_exercise: '',
      form_uid_exercise: '',
      editingExercise: false,

      showModalRegisterExercise: false,
      showModalRegisterTraining: false,

      gifToSave: undefined,

      //search
      search_table_trainings: '',

      messageAll: '',
      messageNewExercise: '',
    };

  }

  componentDidMount() {

  }

  componentWillMount() {

  }

  registerExercise(exercise) {

    //Caso haja um exercício popula-se o formulário com os respectivos valores
    if (exercise) {

      //Obtendo o nome da categoria. MELHORAR ISSO!!!!
      //Possível solução, transformar a categorysListUtils em um mapa que se acessa pela key
      let thatCategory = '';
      for (let i = 0; i < categorysListUtils.length; i++) {
        console.log("COMPARE: " + categorysListUtils[i].key + "==" + exercise.data.category);
        if (categorysListUtils[i].key == exercise.data.category) {
          thatCategory = categorysListUtils[i].name;
          break;
        }
      }
      this.setState({
        form_uid_exercise: exercise.id,
        form_name_exercise: exercise.data.name,
        form_description_exercise: exercise.data.description,
        messageAll: '',
        messageNewExercise: '',
        messageNewExerciseStatus: '',
        gifToSave: undefined,
        form_url_gif_exercise: exercise.data.url_gif,
        form_category_exercise: thatCategory,
        showModalRegisterExercise: true,
        editingExercise: true,
      })
    } else {
      this.setState({
        form_name_exercise: '',
        form_description_exercise: '',
        form_url_gif_exercise: '',
        messageAll: '',
        messageNewExercise: '',
        messageNewExerciseStatus: '',
        gifToSave: undefined,
        form_category_exercise: categorysListUtils[0].name,
        showModalRegisterExercise: true,
        editingExercise: false,
      })
    }
  }

  handleCloseRegisterExercise() {
    this.setState({
      showModalRegisterExercise: false,
    })
  }

  registerTraining() {
    // this.setState({

    //   showModalRegisterTraining: true,
    // })

    this.props.history.push("/treino/montar");
  }

  handleDetailTraining(training) {

    this.props.history.push({
      pathname: '/treino/montar',
      state: { training: training }
    })

  }

  handleCloseRegisterTraining() {
    this.setState({
      showModalRegisterTraining: false,
    })
  }

  onInputChange(target) {

    //console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  onChangeCategoryExercise(event) {
    console.log(event.target.value)
    this.setState({
      form_category_exercise: event.target.value
    })
  }

  saveNewExercise(editExercise) {

    this.setState({
      load: true,
      messageAll: '',
      messageNewExercise: '',
      messageNewExerciseStatus: '',
    })

    let uidProfessor = JSON.parse(localStorage.getItem("USER")).uid;

    if (this.state.form_name_exercise != '') {

      //Montando usuário
      let exercise = {
        name: this.state.form_name_exercise,
        description: this.state.form_description_exercise,
        category: this.state.form_category_exercise,
      }

      //Existe um exercício já existente sendo apenas editado
      if (editExercise) {

        //Verifica se o gif foi alterado
        //Caso exista alteração no gif, 'gifToSave' é diferente de undefined
        if (this.state.gifToSave) {
          sendGifFileStorage(uidProfessor, this.state.gifToSave, this.state.form_uid_exercise, (response, success) => {
            if (success) {
              //Atualizar o exercício
              //Em caso de sucesso a response é a url do gif salva no storage
              exercise.url_gif = response;
              updateExercise(uidProfessor, this.state.form_uid_exercise, exercise, (response, success) => {

                if (success) {
                  this.setState({
                    messageAll: "Exercício atualizado com sucesso!",
                    messageAllStatus: "success",

                    //Limpando formulário
                    form_uid_exercise: '',
                    form_name_exercise: '',
                    form_description_exercise: '',
                    form_url_gif_exercise: '',
                    gifToSave: undefined,
                    form_category_exercise: categorysListUtils[0].name,
                    showModalRegisterExercise: false,
                    editingExercise: false,

                    load: false,
                  })

                  //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
                  window.scrollTo(0, 0);

                } else {
                  this.setState({
                    messageNewExercise: "Falha ao atualizar o exercício: " + response.message,
                    load: false,
                  })
                }
              })

            } else {
              this.setState({
                messageNewExercise: "Falha ao atualizar Gif: " + response.message,
                load: false,
              })
            }
          })
        } else {

          //Não houve alteração do gif, atualiza-se apenas as informações adicionais
          updateExercise(uidProfessor, this.state.form_uid_exercise, exercise, (response, success) => {

            if (success) {
              this.setState({
                messageAll: "Exercício atualizado com sucesso!",
                messageAllStatus: "success",

                //Limpando formulário
                form_uid_exercise: '',
                form_name_exercise: '',
                form_description_exercise: '',
                form_url_gif_exercise: '',
                gifToSave: undefined,
                form_category_exercise: categorysListUtils[0].name,
                showModalRegisterExercise: false,
                editingExercise: false,

                load: false,
              })

              //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
              window.scrollTo(0, 0);
            } else {
              this.setState({
                messageNewExercise: "Falha ao atualizar o exercício: " + response.message,
                load: false,
              })
            }
          })
        }

      } else {

        //Novo exercício sendo registrado
        registerExercise(exercise, (response, success) => {
          if (success) {
            //Salvar gif caso exista
            //Quando a resposta é sucesso ela vem em formato de doc
            let uidExercise = response.id;
            if (this.state.gifToSave) {
              sendGifFileStorage(uidProfessor, this.state.gifToSave, uidExercise, (response, success) => {
                if (success) {
                  //Atualizar a url do vídeo do exercício
                  //Em caso de sucesso a response é a url do gif salva no storage
                  updateExercise(uidProfessor, uidExercise, { url_gif: response }, (response, success) => {

                    if (success) {
                      this.setState({
                        messageAll: "Exercício salvo com sucesso!",
                        messageAllStatus: "success",

                        //Limpando formulário
                        form_uid_exercise: '',
                        form_name_exercise: '',
                        form_description_exercise: '',
                        form_url_gif_exercise: '',
                        gifToSave: undefined,
                        form_category_exercise: categorysListUtils[0].name,
                        showModalRegisterExercise: false,
                        editingExercise: false,

                        load: false,
                      })

                      //Trazendo scroll pra 0 pra garantir a visibilidade da mensagem
                      window.scrollTo(0, 0);

                    } else {
                      this.setState({
                        messageNewExercise: "Falha ao atualizar link do gif no exercício: " + response.message,
                        load: false,
                      })
                    }
                  })

                } else {
                  this.setState({
                    messageNewExercise: "Falha ao salvar Gif: " + response.message,
                    load: false,
                  })
                }
              })
            }
          } else {
            this.setState({
              messageNewExercise: response.message,
              load: false,
            });
          }
        })
      }


    } else {
      this.setState({
        messageNewExercise: "Insira um nome para o exercício",
        load: false,
      });
    }
  }

  renderOptionsCategorys() {
    return _.map(categorysListUtils, (category) => {
      return (

        // <option value={category.key}>{category.name}</option>

        <If test={true}>
          <If test={this.state.form_category_exercise && this.state.form_category_exercise == category.name}>
            <option value={category.key} selected>{category.name}</option>
          </If>
          <If test={this.state.form_category_exercise != category.name}>
            <option value={category.key}>{category.name}</option>
          </If>
        </If>
      )
    })
  }

  uploadGifExercise() {

    let node = ReactDOM.findDOMNode(this.refs.inputGifExercise);
    if (node && node.focus instanceof Function) {
      node.click();
    }

  }

  handleGifUpload(event) {

    const file = event.target.files[0]

    if (file) {
      this.setState({
        gifToSave: file,
      })
    }

  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  render() {

    return (
      <div className="treinos-list-page">

        {this.state.messageAll != '' ?
          <Alert bsStyle={!this.state.messageAllStatus || this.state.messageAllStatus == '' ? 'warning' : this.state.messageAllStatus}>
            {this.renderMessage(this.state.messageAll)}
          </Alert>
          : null}

        {
          this.props.location.state && this.props.location.state.message != '' ?
            <Alert bsStyle={'success'}>
              {this.renderMessage(this.props.location.state.message)}
            </Alert>
            : null
        }

        <Grid>
          <Row className="infos-body-profile">
            <Col md={12} className="no-p-left no-p-right">
              <Jumbotron>
                <h2>Novo Treino</h2>
                <p>Selecione dentre os vários exercícios cadastrados e monte o treino da forma que quiser</p>
                <p>
                  <Button bsStyle="success" onClick={() => this.registerTraining()}>Cadastrar treino</Button>
                </p>
              </Jumbotron>
            </Col>
          </Row>
        </Grid>

        <Grid>
          <Row className="flex-row">
            <Col xs={9} md={9} className="no-p-left no-p-right text-left">
              <h2 className="label-table">Treinos</h2>
            </Col>
            <Col xs={3} md={3} className="no-p-left no-p-right text-left">
              <FormControl
                name="search_table_trainings"
                type="text"
                value={this.state.search_table_trainings}
                placeholder="Pesquisar treino"
                onChange={(event) => this.onInputChange(event.target)} />
            </Col>
          </Row>
        </Grid>

        <TableTrainings handleDetailTraining={(trainingId) => { this.handleDetailTraining(trainingId) }} search={this.state.search_table_trainings} />

      </div >
    );
  }
}

export default TrainingsList;



// WEBPACK FOOTER //
// src/components/treinos/trainings-list.js